// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.communicationPreferences = (await import('./pages/CommunicationPreferencesHOC')).CommunicationPreferencesHOC;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => {
  return {
    communicationPreferences: {
      name: 'CommunicationPreferencesHOC',
      componentName: 'CommunicationPreferencesHOC',
      chunk: () => import('./pages/CommunicationPreferencesHOC'),
      get component() {
        return ssr
          ? serverPages.communicationPreferences
          : currentRouteName === 'CommunicationPreferencesHOC'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CommunicationPreferencesHOC })));
      },
      path: '/:context?/myaccount/preferences',
      prefetch: [],
      channel: null,
      varnish: false,
    }
  };
};
